// extracted by mini-css-extract-plugin
export default {"stickynav":"headers_stickynav__QIFy6","sidenav":"headers_sidenav__LtHRS"};